import { v1 as uuid } from 'uuid';
import Autocomplete from 'react-autocomplete';
import { navigate } from '@reach/router';
import { SpaceBetween } from 'utils/style/extendable';
import { CollectionItem, ItemAvatar, CollectionContent } from './styles';
import ItemView, {
  IComponentProps as IComponentBaseProps,
  IComponentState as IComponentBaseState,
} from './ItemView';
import { display } from 'components/ErrorView/ErrorDialog';
import Button from 'components/Button';
import {
  item_createNewLink,
  searchProvider,
} from 'store/providers/providerSlice';
import {
  IProviderItemView,
  IProviderItemViewWithData,
} from '../../../../store/providers/providerTypes';
import { gray } from '../../../../utils/style/colors';
import LocalIcon, { LocalIconTypes } from '../../../../ui/LocalIcon';
import { IUsers } from '../../../../store/store';

interface IComponentProps extends IComponentBaseProps {
  users?: IUsers;
}
import i18n from '../../../../i18n';

interface IComponentState extends IComponentBaseState {
  searchResult: IProviderItemView[];
  linkedProviderId: null | number;
  linkedProviderName: string;
  value: string;
}

class LinkView extends ItemView<IComponentProps, IComponentState> {
  private nameId: string;
  constructor(props: IComponentProps) {
    super(props);
    this.state = {
      ...this.state,
      searchResult: [],
      linkedProviderId: null,
      linkedProviderName: '',
      value: '',
    };
    this.nameId = uuid();
  }

  handleChangeSearchInput = (event: any, value: string) => {
    this.setState({ value });
    if (event.target.value !== '') {
      this.props
        .dispatch(
          searchProvider({
            queryString: event.target.value,
            variant: null,
            start: 0,
            count: 10,
          })
        )
        .then(
          (data: any) => {
            this.setState({ searchResult: data.providers });
          },
          (err: any) => {
            display(err);
          }
        );
    } else {
      this.setState({
        searchResult: [],
        linkedProviderId: null,
        linkedProviderName: '',
      });
    }
  };

  onSelectProvider = (value: string, item: IProviderItemView) => {
    this.setState({
      value,
      searchResult: [item],
      linkedProviderId: item.id,
      linkedProviderName: item.name as string,
    });
  };

  renderAutocompleteMenu = (children: React.ReactNode) => {
    return (
      <ul className="autocomplete-content dropdown-content">{children}</ul>
    );
  };

  renderAutocompleteItem = (
    item: IProviderItemView,
    isHighlighted: boolean
  ) => {
    return (
      <li
        className={`item ${isHighlighted ? 'item-highlighted' : ''}`}
        key={item.id}
      >
        <a
          href="#!"
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          {item.name}
        </a>
      </li>
    );
  };

  handelConfirmCreatingNewItem = (item: IProviderItemViewWithData) => {
    if (this.state.linkedProviderId !== null) {
      const newItem = {
        ...item.data,
        linkedProviderId: this.state.linkedProviderId,
        name: this.state.linkedProviderName,
        order: this.props.expectedOrder,
      };
      this.props.dispatch(item_createNewLink({ item: newItem }));
    }
  };

  deleteItemTitle = (name: string) => {
    return i18n.t('deleteLinkTitle', { ns: 'documentManager', name });
  };

  deleteItemMessage = (name: string) => {
    return i18n.t('deleteLinkMessage', { ns: 'documentManager', name });
  };

  onOpenFunction = (item: IProviderItemViewWithData) => {
    return () => {
      const providerId = item.data.linkedProviderId;
      navigate('/content/' + providerId);
    };
  };

  getThumbnail = () => {
    return ['user.svg', gray];
  };

  createNewItem = (item: IProviderItemViewWithData) => {
    return (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      this.handelConfirmCreatingNewItem(item);
    };
  };

  newItemPlaceHolder = () => {
    return i18n.t('newLinkPlaceholder', { ns: 'documentManager', name });
  };

  newItemTitle = () => {
    return i18n.t('newLinkTitle', { ns: 'documentManager', name });
  };

  getCreatingView = () => {
    const [iconType, iconColor] = this.getThumbnail();
    return (
      <CollectionItem>
        <CollectionContent>
          <ItemAvatar>
            <LocalIcon
              iconName={iconType as LocalIconTypes}
              color={iconColor}
              type="lg"
            />
          </ItemAvatar>
          <form onSubmit={this.createNewItem(this.props.item)}>
            <div className="input-field">
              <Autocomplete
                inputProps={{ id: this.nameId }}
                value={this.state.value}
                items={this.state.searchResult}
                getItemValue={(item) => item.name || ''}
                wrapperStyle={{ position: 'relative', display: 'inline-block' }}
                onChange={this.handleChangeSearchInput}
                onSelect={this.onSelectProvider}
                renderMenu={this.renderAutocompleteMenu}
                renderItem={this.renderAutocompleteItem}
              />
              <label htmlFor={this.nameId} className="active">
                {this.newItemTitle()}
              </label>
            </div>
            <SpaceBetween>
              <Button
                type="submit"
                color="green"
                disabled={!this.state.linkedProviderId}
              >
                {i18n.t('confirm', { ns: 'documentManager' }) as string}
              </Button>
              <Button
                color="red"
                onClick={this.handelCancelCreatingNewItemFunction}
              >
                {i18n.t('cancel', { ns: 'documentManager' }) as string}
              </Button>
            </SpaceBetween>
          </form>
        </CollectionContent>
      </CollectionItem>
    );
  };
}

export default LinkView;
